<template>
    <template v-if="!hasSpecialIndustryList">
        <div>
            <ul class="text-base font-semibold leading-7 text-grey-80">
                <li
                    v-for="industry in industriesPrimary"
                    :key="industry"
                    class="inline-block border-r-2 border-grey-30 px-2 first:pl-0 last:border-r-0 last:pr-1"
                    v-html="industry">
                </li>
            </ul>
            <ul
                v-show="showOtherIndustries"
                class="break-word inline text-base font-semibold leading-7 text-grey-80"
            >
                <li
                    v-for="industry in industriesSecondary"
                    :key="industry"
                    class="inline-block border-r-2 border-grey-30 px-1 text-xs first:pl-0 last:border-r-0 last:pr-1"
                    v-html="industry">
                </li>
            </ul>
            <button
                v-if="industriesSecondary.length"
                class="text-xs text-blue-30"
                v-on:click="toggleOtherIndustries"
            >
                Plus {{ industriesSecondary.length }} additional industr{{
                industriesSecondary.length === 1 ? 'y' : 'ies'
                }}
                <IconArrowCircleDown class="inline-block h-3 w-3" />
            </button>
        </div>
    </template>
    <template v-else>
        <strong v-html="agency.industryList_formatted"></strong>
    </template>
</template>

<script>
import IconArrowCircleDown from 'Components/Icons/IconArrowCircleDown';
import { mapGetters } from 'vuex';

export default {
  name: 'AgencyAdvertIndustryList',
  components: { IconArrowCircleDown },
  data: function () {
    return {
      showOtherIndustries: false,
      primaryIndustryCount: 10,
    };
  },
  props: {
    agency: {
      type: Object,
    },
  },
  computed: {
    // ...mapGetters('search', [ 'industryList' ]),
    industries() {
      return (this.agency.IndustryList || '')
        .split(',')
        .filter((val) => val !== null && val.length)
        .map((val) => val.replaceAll(' ', '\xa0')); // Replace spaces with NBSP
    },
    industriesPrimary() {
      return this.industries.slice(0, this.primaryIndustryCount);
    },
    industriesSecondary() {
      return this.industries.slice(this.primaryIndustryCount);
    },
    hasSpecialIndustryList() {
      return this.agency.industryList_formatted != null
    }
  },
  methods: {
    toggleOtherIndustries() {
      this.showOtherIndustries = !this.showOtherIndustries;
    },
  },
};
</script>
